var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('loader',{attrs:{"visible":_vm.loading}}),_c('notifier',{attrs:{"type":"error","message":_vm.messageError,"show":_vm.error}}),_c('notifier',{attrs:{"type":"success","message":_vm.messageSuccess,"show":_vm.success}}),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }